import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import ThemeToggleButton from './ThemeToggleButton';
import './AuthForm.css';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = searchParams.get('token') || '';

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
    if (submitError) {
      setSubmitError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!tokenFromUrl) {
      newErrors.token = 'Ссылка для сброса пароля недействительна';
    }

    if (!formData.password) {
      newErrors.password = 'Пароль обязателен';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Минимум 6 символов';
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Пароли не совпадают';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    setSubmitError('');

    try {
      const data = await authService.resetPassword(tokenFromUrl, formData.password);
      setSuccessMessage(data.message || 'Пароль успешно изменён');
    } catch (error) {
      setSubmitError(error.message || 'Не удалось сменить пароль');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password-page">
      <ThemeToggleButton className="reset-password-theme-toggle" />
      <div className="auth-form-shell auth-form-shell--panel reset-password-panel">
        <div className="auth-form-header">
          <h2>Новый пароль</h2>
          <p>Задайте новый пароль для вашего аккаунта</p>
        </div>

        {successMessage ? (
          <div className="reset-password-success">
            <div className="auth-form-banner auth-form-banner--success" role="status">
              {successMessage}
            </div>
            <button type="button" className="auth-submit-btn" onClick={() => navigate('/')}>
              Перейти ко входу
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form" noValidate>
            {!tokenFromUrl && (
              <div className="auth-form-banner auth-form-banner--error" role="alert">
                Ссылка для сброса пароля недействительна. Запросите восстановление пароля заново.
              </div>
            )}

            {submitError && (
              <div className="auth-form-banner auth-form-banner--error" role="alert">
                {submitError}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="reset-password">Новый пароль</label>
              <input
                type="password"
                id="reset-password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                className={errors.password ? 'auth-field-error' : ''}
                placeholder="Минимум 6 символов"
                disabled={isLoading || !tokenFromUrl}
                autoComplete="new-password"
              />
              {errors.password && <span className="error-message">{errors.password}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="reset-confirm-password">Подтвердите пароль</label>
              <input
                type="password"
                id="reset-confirm-password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                className={errors.confirmPassword ? 'auth-field-error' : ''}
                placeholder="Повторите пароль"
                disabled={isLoading || !tokenFromUrl}
                autoComplete="new-password"
              />
              {errors.confirmPassword && (
                <span className="error-message">{errors.confirmPassword}</span>
              )}
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={isLoading || !tokenFromUrl}
            >
              {isLoading ? 'Сохранение...' : 'Сохранить пароль'}
            </button>
          </form>
        )}

        {!successMessage && (
          <div className="auth-form-footer">
            <button type="button" className="auth-switch-btn" onClick={() => navigate('/')} disabled={isLoading}>
              Вернуться ко входу
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
